<template>
  <div>
    <nav>
      <button @click="showModal = true" class="nav-link">
        <icon icon="feather:plus" width="18" class="icon" />增加
      </button>
      |
      <button @click="handleLogout" class="nav-link">登出</button>
    </nav>
    <div class="home">
      <stock-list ref="stockList" />
    </div>

    <!-- AddStock Modal Component -->
    <add-stock
      :visible="showModal"
      :account="user ? user.account : ''"
      @close="showModal = false"
      @stock-added="refreshStockList"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import StockList from "@/components/StockList.vue";
import AddStock from "@/components/AddStock.vue"; // Import the new component
import { Icon } from "@iconify/vue";

export default {
  name: "HomeView",
  components: {
    StockList,
    Icon,
    AddStock, // Register AddStock component
  },
  data() {
    return {
      showModal: false, // Controls modal visibility
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    async handleLogout() {
      try {
        await this.$store.dispatch("logout"); // Call Vuex logout action
        this.$router.push({ name: "login" }); // Redirect to login page
      } catch (error) {
        console.error("Logout failed:", error);
      }
    },
    async refreshStockList() {
      try {
        await this.$refs.stockList.refresh();
        console.log("Stock list refreshed");
      } catch (error) {
        console.error("Failed to refresh stock list:", error);
      }
      // Implement refresh logic for StockList if needed
    },
  },
  mounted() {
    // Debug log (optional, can be removed if not needed)
    return;
  },
};
</script>

<style lang="scss" scoped>
$primary: #4dba87;

.home {
  text-align: center;
  padding: 0px;
}

nav {
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0 0 4px;
  min-height: unset;
}
.main-stock-list {
  margin-top: 0;
}
.nav-link {
  display: inline-block;
  margin-top: 0px;
  padding: 5px 10px;
  line-height: 1.1;
  background: $primary;
  color: white;
  text-decoration: none;
  border: none;
  border-radius: 15px;
  transition: background 0.3s;
  cursor: pointer;
  font-size: 1.2em;

  &:hover {
    background: darken($primary, 10%);
  }

  .icon {
    vertical-align: middle;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
  }
}
</style>
